import {
  fun_PostAction,
  fun_GetAction,
  fun_UploadImg,
  fun_Download
} from "@/api/index";
// 引入转译方法
import { fun_DownloadFile } from "@/utils/validate";
import PDFDialog from "../../components/pdfDialog/index.vue";
export default {
  data() {
    return {
      // 折叠面板
      activeNames: ["1"],
      // 默认关闭
      dialogVisible: false,
      // 图片预览dialog
      imgVisible: false,
      // 加载
      loading: false,
      // 表头按钮组
      btnList: [
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 查询表单绑定值
      form: {
        fileName: null, // 附件名称
        recordNumber: null // 数据编号
      },
      // 查询表单基础数据
      formSearchList: [],
      // 表格基础数据
      tableColumns: [
        {
          label: "上传文件名",
          prop: "fileName"
        },
        {
          label: "操作",
          slotName: "operation",
          width: 180
        }
      ],
      // 列表数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      total: 0,
      pictureFiles: [], //
      // 图片路径
      imgUrl: null,
    };
  },

  // 接收父组件传递的数据
  props: {
    // 页面类型
    controllerFlg: {
      type: String
    },
    // 数据编号
    recordNumber: {
      type: String
    },
    // 文件类型
    fileType: {
      type: String
    },
  },
  // 注册组件
  components: {
    PDFDialog
  },
  // 模板编译完成
  mounted() {},
  // 自定义方法
  methods: {
    // 打开弹框时调用
    async fun_GetOpen() {
      // 如果父组件数据编号不为空
      if (this.recordNumber != "" && this.recordNumber != null) {
        // 设置表单中的数据编号
        this.form.recordNumber = this.recordNumber;
      }
      // 如果操作类型是详情
      if (this.controllerFlg == "details" || this.controllerFlg == "detail") {
        // 清空表头
        this.btnList = [];
      }
      // 查询一览数据
      this.fun_GetList();
    },
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开loading
      this.loading = true;
      // 发起请求
      fun_PostAction("/attachment/list", {
        ...this.form,
        ...this.reqPageData
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      });
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 付翔
     */
    fun_click(e) {
      switch (e) {
        case "删除":
          this.fun_Del();
          break;
        default:
      }
    },
    /**
     * 删除文件
     */
    fun_Del() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 主键集合
        let keys = [];
        // 遍历勾选
        for (const index in this.multipleSelection) {
          // 赋值主键集合
          keys[index] = this.multipleSelection[index].id;
        }
        // 弹出询问confirm
        this.$confirm("是否确定删除选中数据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 请求，获取结果集
          fun_PostAction("/attachment/delete", {
            keys: keys
          }).then(res => {
            // 解构res.data
            const { msg } = res.data;
            // 操作成功
            this.$message.success(msg);
            // 刷新表单
            this.fun_GetList();
          });
        });
      }
      // 如果未进行勾选
      else {
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning");
      }
    },
    /**
     * 文件上传
     */
    fun_FileDetail(file, fileList) {
      // 限制小于5M
      const is5M = file.size / 1024 / 1024 < 5;
      // 判断文件是否小于30MB
      if (!is5M) {
        // 清除验证不通过的文件
        this.fun_ClearFile(file, "fileUpload");
        // 提示错误消息
        this.$message.error("上传的文件大小不可超过5MB");
        // 返回
        return false;
      }
      // 获取文件后缀名
      const suffix = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
      // 如果文件类型为0
      if(this.fileType == "0"){
        // 这里限定上传文件文件类型必须为pdf，如果文件类型不符，提示错误信息
        if (suffix != 'pdf') {
          // 清除验证不通过的文件
          this.fun_ClearFile(file, "fileUpload");
          // 提示错误消息
          this.$message.error("错误提示:上传文件应该为pdf格式，请重新选择文件后上传");
          // 返回
          return false;
        }
      }
      // 如果上传文件大于1
      if (fileList.length > 1) {
        // 根据下标删除列表中的文件
        this.$refs[fileList].uploadFiles.splice(0, 1);
      }
      // 加入集合
      this.pictureFiles.push(file);
    },
    /**
     * 清空文件
     */
    fun_ClearFile(file, refsName) {
      // 获取上传文件的uid
      const uid = file.uid;
      // 获取超过限制大小文件的下标
      const idx = this.$refs[refsName].uploadFiles.findIndex(
        item => item.uid === uid
      );
      // 清空附件列表
      this.$refs[refsName].uploadFiles.splice(idx, 1);
    },
    /**
     * 文件下载
     */
    fun_Download(e) {
      // 获取id
      fun_Download("/downloadLocal?filePath=" + e).then(res => {
        if (res) {
          // 获取头部
          let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;filename
          let regFileNames = fileNames.match(/=(.*)$/)[1];
          fun_DownloadFile(res, decodeURIComponent(regFileNames));
        }
      });
    },
    /**
     * 预览
     */
    fun_Preview(e) {
      // 如果图片类型是jpg或者png
      if (
        e.filePath.substring(
          e.filePath.lastIndexOf(".") + 1,
          e.filePath.length
        ) === "jpg" ||
        e.filePath.substring(
          e.fileName.lastIndexOf(".") + 1,
          e.fileName.length
        ) === "png"
      ) {
        // 预览图片
        this.fun_LookImg(e.filePath);
      }
    },
    /**
     * 图片预览
     */
    fun_LookImg(e) {
      // 获取id
      fun_Download("/downloadLocal?filePath=" + e).then(res => {
        if (res) {
          if (res.data.type === "application/json") {
            this.$message.error("文件不存在！");
            return;
          }
          // 存储this
          const _this = this;
          const data = new Blob([res.data]);
          this.fun_GetBlobToBase64(data).then(res => {
            // 打开弹窗
            this.imgVisible = true;
            // 回显图片
            _this.imgUrl = res;
          });
        }
      });
    },
    /**
     * 转为base64URL
     * @author 滕威
     */
    fun_GetBlobToBase64(blob) {
      return new Promise((resolve, reject) => {
        // 创建文件对象
        const reader = new FileReader();
        reader.onload = e => {
          resolve(e.target.result);
        };
        reader.readAsDataURL(blob);
        reader.onerror = () => {
          reject(new Error("文件流异常！"));
        };
      });
    },
    /**
     * 在线阅读
     */
    fun_PdfLook(e) {
      // 打开弹窗
      this.$refs.pdfDialog.dialogVisible = true;
      // 路径
      this.$refs.pdfDialog.pdfUrl = e;
      // 表头
      this.$refs.pdfDialog.title = "在线阅读";
      // 默认调用
      this.$refs.pdfDialog.fun_GetOpen();
    },
    /**
     * 保存上传附件图片
     */
    fun_Save() {
      // 如果选择的图片名
      if (this.form.fileName == "" || this.form.fileName == null) {
        // 提示，并清除选中数据
        this.$alert("文件名不能为空！", "warning");
        return;
      }
      // 定义formData
      let formData = new FormData();
      // 设置图片名称
      formData.append("fileName", this.form.fileName);
      // 设置数据编号
      formData.append("recordNumber", this.form.recordNumber);
      // 如果上传附件不为空
      if (this.pictureFiles.length > 0) {
        // 设置文件
        formData.append("file", this.pictureFiles[0].raw);
      }
      // 请求
      fun_UploadImg("/attachment/saveOrUpdate", formData).then(res => {
        // 解构res.data
        const { result, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 操作成功
          this.$message.success(msg);
          // 清空文件名
          this.form.fileName = "";
          // 清空文件
          this.pictureFiles = [];
          // 刷新表单
          this.fun_GetList();
        } else {
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
          // 刷新表单
          this.fun_GetList();
        }
        // 关闭loading
        this.loading = false;
      });
    },
  }
};
